import React, { useState, useEffect } from "react";
import NavbarFive from "./NavbarFive";
import Footer from "./Footer";
import Preloader from "./Preloader";
import ComingSoon from "./ComingSoon";
import { useSelector } from "react-redux";
import { isComingSoon } from "../../utils/helper";

/**
 * Common page layout wrapper with standard loading state, navigation,
 * coming soon check and footer
 *
 * @param {Object} props Component props
 * @param {string} props.pageName Name of the page for coming soon check
 * @param {React.ReactNode} props.children Page content
 * @param {boolean} props.showLoader Whether to show initial loader
 * @param {number} props.loaderTimeout Time in ms before hiding loader
 * @param {boolean} props.checkComingSoon Whether to check for coming soon status
 * @returns {JSX.Element} Wrapped page component
 */
const PageLayout = ({
  pageName,
  children,
  showLoader = true,
  loaderTimeout = 1500,
  checkComingSoon = true,
}) => {
  const [loader, setLoader] = useState(showLoader);
  const { homeData } = useSelector((state) => state.pageContents);

  useEffect(() => {
    if (showLoader) {
      setTimeout(() => setLoader(false), loaderTimeout);
    }
  }, [showLoader, loaderTimeout]);

  if (
    checkComingSoon &&
    homeData?.comingsoon &&
    isComingSoon(homeData.comingsoon, pageName)
  ) {
    return <ComingSoon />;
  }

  return (
    <>
      <NavbarFive />
      {/* Ensure children is rendered */}
      {children}
      <Footer />
      {loader ? <Preloader /> : null}
    </>
  );
};

export default PageLayout;
